import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { createLegalSaga } from "src/store/legal/saga";
import { LEGAL_SLUGS, toBody } from "./mapping";
import * as Yup from "yup";

const LegalCreateForm = ({
  onHide,
  open,
  onSuccessClick,
}: {
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("Legal.CreateFormTitle").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        Slug: "",
        Order: 0,
        IsActive: true,
        EffectiveDate: "",
        Title: "",
        Body: "",
        Translates: languages.map((x) => ({
          LanguageId: x.EnumId,
          Title: "",
          Body: "",
        })),
      }}
      onSubmit={(values) => {
        dispatch(
          createLegalSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            body: toBody(values, languages),
          })
        );
      }}
      validationSchema={Yup.object().shape({
        Slug: Yup.string().required(t("Validation.Required").toString()),
      })}
      multilanguageinputs={[
        { field: "Title", label: t("Legal.Title").toString() },
        { field: "Body", label: t("Legal.Body").toString(), isEditor: true },
      ]}
      inputs={[
        {
          field: "Slug",
          label: t("Legal.Slug").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: LEGAL_SLUGS },
        },
        { field: "Order", label: t("Legal.Order").toString() },
        { field: "EffectiveDate", label: t("Legal.EffectiveDate").toString() },
        { field: "IsActive", label: t("Legal.IsActive").toString(), type: "switch" },
      ]}
    />
  );
};
export default LegalCreateForm;
